import "@fontsource/montserrat"; // Defaults to weight 400.
import "@fontsource/montserrat/500.css"; // Weight 500.
import "@fontsource/montserrat/900.css";
import "@fontsource/montserrat/600.css";

import { createGlobalStyle, keyframes } from "styled-components";

import { colors } from "./Variables";

export const CONTAINER_WIDTH_PX = 1048;
export const TOP_NAV_LAYOUT_CONTAINER_WIDTH_PX = 1148;
export const TOP_NAV_CONTENT_MIN_WIDTH_PX = 1048;
export const TOP_NAV_CONTENT_MAX_WIDTH_PX = 1440;
export const TOP_NAV_MAITE_CONTENT_MIN_WIDTH_PX = 620;
export const TOP_NAV_MAITE_CONTENT_MAX_WIDTH_PX = 1048;
export const DRAWER_WIDTH_PX = 300;
export const DRAWER_BREAKPOINT = 1440;
export const DRAWER_COLLAPSED_WIDTH_PX = 80;

const slideInFromBottom = keyframes`
0% {
    transform: translate(-50%, 100%);
  }
  100% {
    transform: translate(-50%, -50%);
  }
`;

// MUI breakpoints
export const breakpoints = {
  xs: 0, // 0px
  sm: 600, // 600px
  md: 900, // 900px
  lg: 1200, // 1200px
  xl: 1536, // 1536px
};

export const GlobalStyle = createGlobalStyle`
html{
  min-height: 100%; 
  position: relative;
}
body {
    background-color: ${(props) =>
      props.theme !== undefined && props.theme.mode === "light"
        ? colors.white
        : "#282827"}  !important;
    color: ${(props) =>
      props.theme !== undefined && props.theme.mode === "light"
        ? colors.bodyMain
        : colors.white} !important;
    padding: 0;
    margin: 0;
    font-family: 'Montserrat', sans-serif; 
    font-size: 13px;
    font-weight: 200;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: -0.14px;
    width: 100%;
    min-width: 928px;

    .predictFormDetailedView {
      cursor: not-allowed;
      pointer-events: none;
    }

      .react-tooltip-custom {
        opacity: 1 !important;
        box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
      }
    .ReactModal__Content {
      animation: 0.5s ease-out 0s 1 ${slideInFromBottom};
    }

    .ReactModal__Overlay.ReactModal__Overlay--after-open {
      z-index: 999;
    }


    .highcharts-tooltip-box {
      stroke-width: 0;
      fill: ${(props) =>
        props.theme !== undefined && props.theme.mode === "dark" ? colors.gray : colors.white};
      fill: transparent;
      fill-opacity: 1;
    }
   
    .highcharts-csutom-tooltip {
      color: ${colors.white};
      filter: drop-shadow(0px 5px 5px ${colors.black});
      font-size: 11px;       
      fontFamily: "Montserrat",
      font-weight:400;
    }
    .highcharts-csutom-tooltip__inner{
        background-color: ${(props) =>
          props.theme !== undefined && props.theme.mode === "dark" ? colors.gray : colors.white};
        color: ${(props) =>
          props.theme !== undefined && props.theme.mode === "dark" ? colors.white : colors.gray};
        padding: 15px;
        padding-bottom:25px;
        padding-right:25px;
        clip-path: polygon( 0% 0px, /* top left */ 0px 0%, /* top left */ 0px 0%, /* top right */ 100% 0px, /* top right */ 100% calc(100% - 20px), /* bottom right */ calc(100% - 20px) 100%, /* bottom right */ 0px 100% /* bottom left */ );
    }
    .highcharts-custom-tooltip__header {
      display: flex;
      justify-content: start;
      flex-direction: row;
      align-items: center;
      align-content: center;
      fontFamily: "Montserrat",
    }
    .highcharts-custom-tooltip__body {
      fontFamily: "Montserrat";
      margin-top:10px;
    }
    .highcharts-csutom-tooltip__dot{
          height: 15px;
          width: 15px;
          display: inline-block;
          border-radius: 50%;
          margin-right: 10px;
    }
    .highcharts-csutom-datalabel__wrap{
      width:100%;
      height: 100%;
    }
    .highcharts-csutom-datalabel__container{
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      align-content: center;
    }

    .highcharts-csutom-quadrants-wrap-left{
      text-align: left;
      font-family: "Montserrat"; 
      font-size: 10px;         
      line-height: 1.5;  
      color: ${(props) =>
        props.theme !== undefined && props.theme.mode === "dark" ? colors.labelGray : colors.gray};
    }
    .highcharts-csutom-quadrants-wrap-right{
      text-align: right;
      font-family: "Montserrat"; 
      font-size: 10px;         
      line-height: 1.5;  
      color: ${(props) =>
        props.theme !== undefined && props.theme.mode === "dark" ? colors.labelGray : colors.gray};
    }
    .highcharts-csutom-quadrants-header-bold{
      font-weight:600;
    }
    .highcharts-csutom-quadrants-body{

    }

    .tooltip-custom__bold_600 {
      font-family: "Montserrat";            
      font-weight:600;
      font-size: 11px;
      margin-right: 10px;
    }

    .rechart-csutom-tooltip {
      color: ${colors.white};
      filter: drop-shadow(0px 5px 5px ${colors.black});
      font-size: 11px;

      &__inner {
        background-color: ${(props) =>
          props.theme !== undefined && props.theme.mode === "dark" ? colors.gray : colors.white};
        color: ${(props) =>
          props.theme !== undefined && props.theme.mode === "dark" ? colors.white : colors.gray};
        padding: 15px;
        clip-path: polygon( 0% 0px, /* top left */ 0px 0%, /* top left */ 0px 0%, /* top right */ 100% 0px, /* top right */ 100% calc(100% - 20px), /* bottom right */ calc(100% - 20px) 100%, /* bottom right */ 0px 100% /* bottom left */ );
      }
    }


    input {
      font-family: "Montserrat";
    }
    .recharts-custom-legend {
      font-weight:400;
      list-style: none;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-right: 5px;
      margin-top: 5px;
      font-size: 10px;
     

      &:hover {
        color: ${colors.lightGreen} !important;
       
      }
    }

    .recharts-custom-label {
      font-weight:400;
      &:hover {
        fill: ${colors.lightGreen};
      }
    }

    .echarts-custom-tooltip {
      width: 100%;
      height: 100%;
      background-color: ${(props) =>
        props.theme !== undefined && props.theme.mode === "dark" ? colors.cardBg : colors.white};
      color: ${(props) =>
        props.theme !== undefined && props.theme.mode === "dark" ? colors.white : colors.cardBg};
      padding: 10px;
      clip-path: polygon(
        0% 0px,
        0px 0%,
        0px 0%,
        100% 0px,
        100% calc(100% - 20px),
        calc(100% - 20px) 100%,
        0px 100%
      );
      &__inner {
        display: flex;
        align-items: center;
        padding: 10px 0;
        width: 100%;
       height: 100%;
      }

      p {
        margin-block-start: 0;
        margin-block-end: 0;
      }

      &__circle {
        display: inline-block;
        margin-right: 5px;
        border-radius: 10px;
        width: 15px;
        height: 15px;
      }

      &__bold {
        font-weight: 600;
      }
      &__second-title {
        margin-top: 10px !important;
      }
    }

    .d3-graph-tooltip {
      color: ${colors.white};
      display: none;

      span {
        font-size: 11px;
      }

      filter: drop-shadow(0px 5px 5px ${colors.black});
      &__dot {
          height: 15px;
          width: 15px;
          display: inline-block;
          border-radius: 50%;
          margin-right: 5px;
      }
      &__inner {
        background-color: ${(props) =>
          props.theme !== undefined && props.theme.mode === "dark" ? colors.gray : colors.white};
        color: ${(props) =>
          props.theme !== undefined && props.theme.mode === "dark" ? colors.white : colors.gray};
        padding: 15px;
        clip-path: polygon( 0% 0px, /* top left */ 0px 0%, /* top left */ 0px 0%, /* top right */ 100% 0px, /* top right */ 100% calc(100% - 20px), /* bottom right */ calc(100% - 20px) 100%, /* bottom right */ 0px 100% /* bottom left */ );
      }
      &__paragraph {
          display: flex;
          justify-content: center;
          align-items: center;  
      }
      &__bold {
        font-weight: 600;
        font-size: 11px;

        span {
          font-size: 11px;
        }
      }
    }
    .d3-graph-axis { 
      
      .label-wrapper {
        display: flex;
        flex-direction: column;
      }
      .label-top-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        margin-top: 0;
        font-size: 11px;
        
      }
      .label-bottom-wrapper {
        display: flex;
        justify-content: center;
        margin-top: -8px;
        cursor: pointer;
        font-size: 11px;
      }
      .domain {
        stroke: none;
      }
      .tick {
        line {
          stroke: ${colors.lightGray};
        }
      }
      
    }
    .x-axis.d3-graph-axis {
      .tick {
        text {
          display: none;
        }
      }
    }
  


    .form-control.input {
      background: transparent;
      color: ${colors.textMain};
      height: 24px;
      border: thin solid ${colors.textMain};
      border-radius: 4px;
      min-width: 150px;
      padding: 5px 20px;  
      font-size: 12px;
      font-family: "Montserrat";
      &:hover, &:focus {
        border: thin solid ${colors.yellow};
        outline: none;
       } 
    }
    .flatpickr-calendar { 
      width: 349px;
      padding: 40px 20px;
      background: ${colors.cardBg};
      box-shadow: 1px 4px 4px 0px rgba(0, 0, 0, 0.6);
      .numInputWrapper {
         .arrowUp,  .arrowDown {
            opacity:1;
         }
      }
      .prevMonthDay, .nextMonthDay  {
        visibility: hidden;
      }
      .flatpickr-month {
        font-size: 12px;
        margin-bottom: 31px;
        margin-top: -36px;
        background: ${colors.cardBg} !important;
      .flatpickr-monthDropdown-months {
        background: ${colors.cardBg};
        .flatpickr-monthDropdown-month {
          background: ${colors.cardBg} !important;
          &:hover {
            background: ${colors.yellow} !important;
          }
        }
      }
    }
    &:before, &:after {
      display: none;
    }    
    
    .flatpickr-innerContainer {
      background: ${colors.cardBg};
    }
    .flatpickr-day {
      color: ${colors.white};
      &:hover {
        background: ${colors.yellow};
        border-color: ${colors.yellow};
        color: ${colors.black};
      }
    } 
    .flatpickr-disabled {
      opacity: 0.4;
      &:hover {
        background: transparent;
        border: none;
        color: ${colors.white};
      }
    }
    .flatpickr-weekdays, .flatpickr-weekday {
      background: ${colors.cardBg};
      color: ${colors.white};
    }
    .flatpickr-day.selected.startRange, .flatpickr-day.selected.endRange {
      background: ${colors.yellow};
      border-color: ${colors.yellow};
      color: ${colors.black};
      box-shadow:none;
    }
    .flatpickr-day.inRange {
      background: rgb(255,212,0, 0.6);
      border: none; 
      color: ${colors.black};
      box-shadow: -5px 0 0 rgb(255,212,0,0.6), 0px 0 0 rgb(255,212,0,0.2);
    }
  }
}

.disable-body-scroll {
  overflow: hidden;
}

  #root {
    height: 100%;
  }

  a {
    text-decoration: none;
  }

  li {
    list-style-type: none;
  }
  .graph-open {
    top: 215px;
    left: 0;
    right: 0;
    position: fixed !important;
    display: block;
    height: 100%;
    width: 100%;
    z-index: 1;
    overflow-y: scroll;
    padding: 0;
    width: 994px !important;
    margin: 0 auto;
    background-color: ${(props) =>
      props.theme !== undefined && props.theme.mode === "dark" ? "rgb(40, 40, 39)" : colors.white};

  }
    .graph-open-review {
    top: 256px;
    left: 0;
    right: 0;
    position: fixed !important;
    display: block;
    height: 100%;
    width: 100%;
    z-index: 1;
    overflow-y: scroll;
    padding: 0;
    width: 994px !important;
    margin: 0 auto;
    background-color: ${(props) =>
      props.theme !== undefined && props.theme.mode === "dark" ? "rgb(40, 40, 39)" : colors.white};
  }

  #card-content {
    display: flex;
    width: 100%;
    margin: 0 auto;
    background-color: ${(props) =>
      props.theme !== undefined && props.theme.mode === "dark" ? "transparent" : colors.white};
  }

  #chartjs-tooltip {
    z-index: 999;
  }


  .echarts-custom-hover-tooltip_grid-container{
    display: flex;
		flex-direction: column;
		flex-wrap: wrap;
  }
  .echarts-custom-hover-tooltip_title{
    margin-bottom: 10px;
  }
  .echarts-custom-hover-tooltip_legend-wrap{
    display: flex;
    margin-bottom: 10px;
  }
  .echarts-custom-hover-tooltip_legend-circle{
    display:inline-block;
    margin-right: 5px;
    border-radius: 50%;
    width:13px;
    height:13px
  }

  .multine-ellipsis {
    -webkit-box-orient: vertical;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  .ant-picker-panel-layout {
    height: 364px;
  }

  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-presets ul li {
    padding: 0;
  }
`;
